export const copyLink = (url: string): Promise<void> => {
	return navigator.clipboard.writeText(url)
}
